<template>
  <div class="character">
    <h2 class="character__title">
      {{model.title}} <span v-if="model.isRequired" class="color-red">*</span>
    </h2>
    <div class="character__wrap" :class="{'character__wrap--invalid': model.invalid}">
      <div v-show="model.invalid" class="character__popup">
        <p v-for="(error, i) in errors" :key="i">{{error}}</p>
      </div>
      <div @click="toggle" class="character__top">
        <div v-show="!opened" class="character__placeholder">
          1. Выбор характеристики позиции
        </div>
        <button class="btn-toggle character__toggle"
          :class="{'character__toggle--opened': opened}">Toggle</button>
        <button v-tooltip="model.comment" @click.stop
          class="btn-toggle character__info" :disabled="!model.comment">Tooltip</button>
      </div>
      <div v-show="opened" class="character__content">
        <label v-for="(val, i) in model.values"
          :key="i" class="custom-checkbox">
          <input type="checkbox" class="custom-checkbox__native sr-only"
            v-model="value" @change="update" :value="val">
          <span class="custom-checkbox__input">Custom Checkbox</span>
          <span class="custom-checkbox__text">{{val}}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: ['model'],
  data() {
    return {
      value: [],
      opened: false,
      errors: [],
    };
  },
  mounted() {
    if (this.model.isRequired) {
      this.errors.push('Необходимо заполнить это поле');
    }
  },
  methods: {
    update() {
      const { title, comment, isRequired } = this.model;
      const { value } = this;
      this.errors = [];
      if (isRequired && !value.length) {
        this.errors.push('Необходимо заполнить это поле');
      }
      this.$emit('update', {
        title,
        value,
        comment,
        isRequired,
        model: this.model,
      });
    },
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>
